import { useSelector } from "react-redux";
import BillDetail from "../components/BillDetail";
import CardItem from "../components/CardItem";

const CartPage = () => {
  const carts = useSelector((state) => state.carts.cartItems);
  return (
    <main className="py-16">
      <div className="container 2xl:px-8 px-2 mx-auto">
        <h2 className="mb-8 text-xl font-bold">Shopping Cart</h2>
        <div className="cartListContainer">
          <div className="space-y-6">
            {carts.length > 0 ? (
              carts.map((cart) => <CardItem key={cart.id} cart={cart} />)
            ) : (
              <div>Your Cart is Empty</div>
            )}
          </div>

          <div>
            <BillDetail />
          </div>
        </div>
      </div>
    </main>
  );
};

export default CartPage;
